import { SingleFieldDynamicFields } from '../singleFieldDynamicFields';
import { FormikProps } from 'formik';
import { Typography } from '@mui/material';
import { SingleDynamicField } from '../../../../../shared/types/assistant';

export const KnowledgeBaseRules = ({
    formikKnowledgeBaseRules,
}: {
    formikKnowledgeBaseRules: FormikProps<{
        [key: string]: SingleDynamicField[];
    }>;
}) => {
    return (
        <SingleFieldDynamicFields
            formik={formikKnowledgeBaseRules}
            name="knowledgeBaseRules"
            label="Reglas de Uso de la Biblioteca de Conocimiento"
            description="Define las reglas que deben seguirse al usar la biblioteca de conocimiento. Especifica instrucciones clave, como cómo consultar la información, restricciones en las respuestas y cualquier requisito adicional."
            example={
                <Typography color="text.secondary">
                    Consulta la base antes de responder.
                </Typography>
            }
            rows={1}
        />
    );
};
